"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityBaseModel = void 0;
var mobx_1 = require("mobx");
var EntityBaseModel = /** @class */ (function () {
    function EntityBaseModel(id) {
        this.id = id;
        this.deleting = false;
        this.deleted = false;
        this.updating = false;
        this.updated = false;
        this.selected = false;
        this.omittedKeys = [];
    }
    EntityBaseModel.getStore = function () {
        var store = this._store;
        if (!store) {
            console.error("_store not defined in " + this + "\n            Please define _store and assign 'this' to it in parent store's constructor");
        }
        return store;
    };
    EntityBaseModel.fromJson = function (json, identifierKey) {
        if (identifierKey === void 0) { identifierKey = 'id'; }
        if (!json) {
            return null;
        }
        var id = json[identifierKey];
        var entity = this.getOrNew(id);
        entity.updateFromJson(json);
        return entity;
    };
    EntityBaseModel.getOrNew = function (id) {
        var entity = this.getStore().get(id);
        if (!entity) {
            entity = new this(id);
            this.getStore().push(entity);
        }
        return entity;
    };
    EntityBaseModel.get = function (id) {
        return this.getStore().get(id);
    };
    EntityBaseModel.prototype.delete = function () {
        this.deleted = true;
    };
    EntityBaseModel.prototype.setIsSelected = function (selected) {
        this.selected = selected;
    };
    EntityBaseModel.prototype.setDeleting = function (value) {
        this.deleting = value;
    };
    EntityBaseModel.prototype.setUpdating = function (value) {
        this.updating = value;
    };
    EntityBaseModel.prototype.toggleSelected = function () {
        this.setIsSelected(!this.selected);
    };
    EntityBaseModel.prototype.updateFromJson = function (json) {
        var _a;
        for (var k in json) {
            if (!json.hasOwnProperty(k)) {
                continue;
            }
            if (this.omittedKeys && this.omittedKeys.indexOf(k) !== -1) {
                continue;
            }
            var deserializer = this.getDeserializer(k);
            var currentObject = this;
            if (deserializer) {
                json[k] && deserializer.bind(this)(json[k]);
            }
            else if (currentObject[k] && currentObject[k].deserialize) {
                currentObject[k].deserialize(((_a = json[k]) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('data')) ? json[k].data : json[k]);
            }
            else {
                currentObject[k] = json[k];
            }
        }
    };
    EntityBaseModel.prototype.getDeserializer = function (prop) {
        var _methodName = "deserialize_" + prop;
        return this[_methodName];
    };
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "deleting", void 0);
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "deleted", void 0);
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "updating", void 0);
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "updated", void 0);
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "selected", void 0);
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "created_at", void 0);
    __decorate([
        mobx_1.observable
    ], EntityBaseModel.prototype, "updated_at", void 0);
    __decorate([
        mobx_1.action
    ], EntityBaseModel.prototype, "delete", null);
    __decorate([
        mobx_1.action
    ], EntityBaseModel.prototype, "setIsSelected", null);
    __decorate([
        mobx_1.action
    ], EntityBaseModel.prototype, "setDeleting", null);
    __decorate([
        mobx_1.action
    ], EntityBaseModel.prototype, "setUpdating", null);
    __decorate([
        mobx_1.action
    ], EntityBaseModel.prototype, "updateFromJson", null);
    return EntityBaseModel;
}());
exports.EntityBaseModel = EntityBaseModel;
exports.default = EntityBaseModel;
